import React from "react";
import { Switch } from "antd";
import styles from "./ecd-program-toggle.module.css";
import { useSelector } from "react-redux";

const ECDProgramToggle = ({ isECDProgram, updateECDProgram }) => {
  const user = useSelector((state) => state.user?.user);
  if (user?.school_type !== "PRIMARY") return null;

  return (
    <div
      className={`${styles.ecdContainer} ${
        !isECDProgram ? styles.inactive : ""
      }`}
    >
      <div className={styles.textWrapper}>
        <div className={styles.title}>ECD Program</div>
        <div className={styles.subtitle}>
          Switch on ‘ECD Programs’ to schedule and manage assessments for
          Early Childhood Development (ECD A & B) learners.
        </div>
      </div>

      <Switch
        checked={isECDProgram}
        onChange={updateECDProgram}
        className={styles.switch}
      />
    </div>
  );
};

export default ECDProgramToggle;
